<template>
  <layout-component>
    <div class="container" v-if="post">
        <div class="row justify-content-md-center banner pb-1 pb-md-0">
          <div class="col-md-7 title-wrapper">
            <div class="date">{{ post.date | formatDateBlog }}</div>
            <h1 class="left-bullet">{{ $i18n.locale == 'fr' ? post.title : post.title_en }}</h1>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="img-wrapper img-header">
              <div class="noise">
                <img class="img-fluid" v-if="post.image" :src="'/storage/'+post.image" />
              </div>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div class="body" v-html="$i18n.locale == 'fr' ? post.body : post.body_en"></div>
          </div>
        </div>

        <div class="row pt-3 pt-md-4 other-posts">
          <div class="col-md-8 pb-2 pb-md-3 offset-md-2">
            <h2 class="left-bullet" v-html="$t('title-01')"></h2>
          </div>

          <div v-for="post in post.otherPosts" class="col-md-6">
            <div class="card-blog">
              <router-link :to="'/blog/post/'+post.slug">
              <div class="img-wrapper">
                <div class="noise">
                  <img class="img-fluid"  v-if="post.image" :src="'/storage/'+post.image" />
                </div>
              </div>
              <div class="text-wrapper">
                <div class="date bottom-cut">{{ post.date | formatDateBlog }}</div>
                <h3>{{ $i18n.locale == 'fr' ? post.title : post.title_en }}</h3>
                <p class="btn-link">{{'title-btn'|t}}</p>
              </div>
              </router-link>
            </div>
          </div>
        </div>


    </div>

	</layout-component>
</template>

<script>
    export default {
      data() {
        return {
          post:null
        }
      },
      created() {
        this.getPost()
      },
      watch: {
        // call again the method if the route changes
        '$route': 'getPost'
      },
      methods: {
        getPost() {
          Vue.axios.get('/blog/'+this.$route.params.id).then( ({data}) => {
            this.post = data
          })
        }
      },
      mounted() {
        $('.title-anim-wrapper:in-viewport').addClass('in-viewport');

        $('.noise').each(function() {
          if ($(this).is( ':in-viewport' ) ) {
            $(this).addClass('in-viewport');
          } else {
            $(this).removeClass('in-viewport');
          }
        });
      }
    }
</script>

<i18n>
    {
      "en": {
        "title-01": "<span class='title-anim-wrapper'><span class='title-anim'>You may be</span></span> <span class='title-anim-wrapper'><span class='title-anim'>interested in</span></span>",
        "title-btn": "Check it"
      },
      "fr": {
        "title-01": "<span class='title-anim-wrapper'><span class='title-anim'>Ceci pourrait</span></span> <span class='title-anim-wrapper'><span class='title-anim'>vous interesser</span></span>",
        "title-btn": "Voir"
      }
    }

</i18n>
